var _defs, _circle, _mask;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayPauseStop02Darkpink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2426c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "play_pause_stop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 94.24,
    mask: "url(#cut-off)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "cut-off"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.66 100 64.66 162.82 96.07 162.82 96.07 37.18 64.66 37.18 64.66 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.93 37.18 103.93 162.82 135.34 162.82 135.34 86.41 135.34 37.18 135.34 37.18 135.34 37.18 103.93 37.18"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPauseStop02Darkpink);
export default __webpack_public_path__ + "static/media/play_pause_stop-02_darkpink.dde469ac256a1ab17a443d0ac354b354.svg";
export { ForwardRef as ReactComponent };